import React from 'react';
import {
  Container, Typography, Paper, List, ListItem, ListItemIcon, ListItemText,
  Alert, Divider, Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';

export default function ReturnPolicy() {
  React.useEffect(() => {
    document.title = '退換貨政策 - 優爾商城';
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AssignmentReturnIcon color="primary" fontSize="large" />
          退換貨政策
        </Typography>

        <Alert severity="info" sx={{ my: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold">退換貨說明</Typography>
          依據消費者保護法，您享有七日鑑賞期權益。若收到的商品有瑕疵，請於鑑賞期內聯繫我們，我們將全額處理退換貨與運費。
        </Alert>

        <Typography variant="h5" fontWeight="bold" sx={{ mt: 3, mb: 2 }}>
          依據消費者保護法第19條
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
            <ListItemText
              primary="7天猶豫期"
              secondary="消費者得於收受商品後七日內，退回商品或以書面通知企業經營者解除買賣契約，無須說明理由及負擔任何費用或價款。"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><WarningIcon color="warning" /></ListItemIcon>
            <ListItemText
              primary="猶豫期非試用期"
              secondary="猶豫期並非試用期，商品必須保持全新狀態（未拆封、未使用），且包裝完整（含外盒、配件、贈品等），否則將影響退貨權益。"
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          不適用七天猶豫期之商品
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          依據消費者保護法第19條第1項但書規定，以下商品不適用七天猶豫期：
        </Typography>
        <List dense>
          {[
            '易於腐敗、保存期限較短或解約時即將逾期之商品',
            '依消費者要求所為之客製化給付',
            '報紙、期刊或雜誌',
            '經消費者拆封之影音商品或電腦軟體',
            '已拆封之個人衛生用品',
            '國際航空客運服務'
          ].map((item, index) => (
            <ListItem key={index}>
              <ListItemIcon><InfoIcon fontSize="small" color="disabled" /></ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          商品瑕疵處理
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          若您收到的商品有瑕疵（非人為損壞），請於鑑賞期（7 天）內聯繫客服，並提供以下資訊：
        </Typography>
        <List dense>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="primary" fontSize="small" /></ListItemIcon>
            <ListItemText primary="訂單編號" />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="primary" fontSize="small" /></ListItemIcon>
            <ListItemText primary="商品瑕疵照片（含外包裝）" />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="primary" fontSize="small" /></ListItemIcon>
            <ListItemText primary="瑕疵說明" />
          </ListItem>
        </List>
        <Typography variant="body2" color="text.secondary">
          客服確認後將安排換貨或退款，運費由本公司負擔。
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            退貨流程
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon><Typography fontWeight="bold" color="primary">1</Typography></ListItemIcon>
              <ListItemText primary="聯繫客服" secondary="透過 LINE 或電話聯繫客服，告知訂單編號及退貨原因。" />
            </ListItem>
            <ListItem>
              <ListItemIcon><Typography fontWeight="bold" color="primary">2</Typography></ListItemIcon>
              <ListItemText primary="寄回商品" secondary="將商品連同所有配件、贈品完整包裝後寄回。退貨運費依退貨原因決定。" />
            </ListItem>
            <ListItem>
              <ListItemIcon><Typography fontWeight="bold" color="primary">3</Typography></ListItemIcon>
              <ListItemText primary="退款處理" secondary="收到退回商品並確認無誤後，將於 7 個工作天內完成退款。" />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            聯絡客服
          </Typography>
          <Typography variant="body2" color="text.secondary">
            如有任何退換貨問題，歡迎透過以下方式聯繫我們：
          </Typography>
          <Typography variant="body2" color="text.secondary">
            LINE 官方帳號：@urstore
          </Typography>
          <Typography variant="body2" color="text.secondary">
            服務時間：週一至週五 09:00-18:00
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
